<template>
  <div id="landing">
    <div class="titleContainer">
      <div class="titleWrapper">
        <BgImage
        class="titleImage"
        :path="'img/both_1440.png'"
        />
        <div class="title-svg">
          <TitleSVG />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import TitleSVG from '../../public/svg/brehm-title.svg';
import BgImage from '../components/BgImage.vue';

export default {
  name: 'landing',
  components: {
    BgImage,
    TitleSVG,
  },
};
</script>

<style lang="scss" scoped>
#landing {
  overflow: hidden;
  height: 100vh;
  height: calc(var(--vh, 1vh) * 100);
  padding-top: 50vh;
  padding-top: calc(var(--vh, 1vh) * 50);
  background-color: #eee;
  background-color: var(--main-background-color);

  .titleContainer {
    position: relative;
    width: 77vw;
    max-width: 50vh;
    max-width: calc(var(--vh, 1vh) * 50);
    margin: 0 auto;
  }
  .titleWrapper {
    position: relative;
    margin-top: -80%;
    overflow: hidden;
  }

  .titleImage {
    display: block;
    width: 100%;
    height: 72vw;
    max-height: 47vh;
    max-height: calc(var(--vh, 1vh) * 47);
  }

  .title-svg {
    position: relative;
    width: 70vw;
    max-width: 49vh;
    max-width: calc(var(--vh, 1vh) * 49);
    margin: 0 auto;
    margin-top: -20%;
    padding: 0;
    padding-top: 7%;
    background-color: #eee;
    background-color: var(--main-background-color);
  }

  .title-svg {
    fill: #333;
    fill: var(--main-text-color);
  }
}
/* @media only screen and (orientation : landscape) {
  .titleImage{
    width: 60vh;
    height: calc(60vh * 0.9324);
    margin-top: 10vh;
  }
  .title-svg {
    width: 60vh;
    padding-top: 5vh;
    top: -12vh;
  }
} */
</style>
